<template>
  <picture class="responsive-image" :data-src="data.src">
    <source
      v-for="(size, k) in data.sizes"
      :key="k"
      :media="'(max-width: ' + size + 'px)'"
      :srcset="filename(size) + ' ' + size + 'w'"
      sizes="auto"
    />
    <img
      loading="lazy"
      decoding="async"
      :src="filename(data.sizes[data.sizes.length - 1])"
      :width="data.width"
      :height="data.height"
      :alt="data.alt"
      title=""
    />
  </picture>
</template>

<script>
export default {
  name: "ResponsiveImage",
  props: {
    data: {
      type: Object,
      default() {
        return {
          sizes: [1280, 640],
          src: "/default.jpg",
          width: "640",
          height: "640",
          alt: "Default Alt"
        };
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    filename(size) {
      const parts = this.data.src.split(".");
      const ext = parts.pop();
      const name = parts.join(".") + "-" + size + "." + ext;
      const file = require("@/assets" + name);
      return file;
    }
  }
};
</script>

<style lang="scss">
.responsive-image {
  display: flex;
  img {
    aspect-ratio: auto;
    object-fit: cover;
  }
}
</style>
